import { ReactNode } from 'react'
import { MainMenuKey } from '../../route'
import { RouteListParam } from '../../tools/public'
import { LoginRes } from '../../api/CommonApi'
import { ExpressCompanyRes } from '../../api/orderManage'

interface enterpriseInfoState {
  corporate?: string
  date?: string
  enterpriseName?: string
  id?: string
  licenseUrl?: string
  regAddress?: string
  regCapital?: string
  regStatus?: string
  uscc?: string
}
export interface CustomMenuItem {
  icon?: ReactNode
  label: string
  key: React.Key
  children?: CustomMenuItem[]
  url?: string
  [key: string]: any
}

type RouterObj = {
  [keyname in MainMenuKey]: RouteListParam[]
}
type MainMenuObj = {
  [keyname in MainMenuKey]: any[]
}
interface State {
  enterpriseInfo?: enterpriseInfoState
  routerObj: RouterObj
  mainMenuObj: MainMenuObj
  orderassuranceTabKey: string
  loginInfo?: LoginRes
  expressList: ExpressCompanyRes[]
}
export type ActionType =
  | 'setEnterpriseInfo'
  | 'setRouterObjAction'
  | 'setMainMenuObjAction'
  | 'setMainMenuListAction'
  | 'setOrderassuranceTabKeyAction'
  | 'setLoginInfoAction'
  | 'setExpressListAction'
  | 'getExpressListAction'

interface Action {
  type: ActionType
  payload?: any
}

export const initialRouterObj: {
  [key in MainMenuKey]: RouteListParam[]
} = {
  基本信息: [],
  物料管理: [],
  询报价: [],
  订单管理: [],
  客户开票: [],
  开票付款: [],
  系统管理: [],
}

export const initialMainMenu: {
  [key in MainMenuKey]: any[]
} = {
  基本信息: [],
  物料管理: [],
  询报价: [],
  订单管理: [],
  客户开票: [],
  开票付款: [],
  系统管理: [],
}
const initialState: State = {
  enterpriseInfo: undefined,
  routerObj: initialRouterObj,
  mainMenuObj: initialMainMenu,
  orderassuranceTabKey: 'CUSTOMER',
  loginInfo: undefined, // 登录接口获取的信息
  expressList: [],
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setEnterpriseInfo':
      newstate.enterpriseInfo = action.payload
      return newstate
    case 'setRouterObjAction':
      newstate.routerObj = action.payload
      return newstate
    case 'setMainMenuObjAction':
      newstate.mainMenuObj = action.payload
      return newstate
    case 'setOrderassuranceTabKeyAction':
      newstate.orderassuranceTabKey = action.payload
      return newstate
    case 'setLoginInfoAction':
      newstate.loginInfo = action.payload
      return newstate
    case 'setExpressListAction':
      newstate.expressList = action.payload
      return newstate
    default:
      return newstate
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
export const setEnterpriseInfo = (val: any): Action => ({
  type: 'setEnterpriseInfo',
  payload: val,
})

/**
 * 设置整理好的路由对象
 * @param val
 * @returns
 */
export const setRouterObjAction = (val: RouterObj): Action => ({
  type: 'setRouterObjAction',
  payload: val,
})

/**
 * 设置整理好的主菜单
 * @param val
 * @returns
 */
export const setMainMenuObjAction = (val: MainMenuObj): Action => ({
  type: 'setMainMenuObjAction',
  payload: val,
})

export const setOrderassuranceTabKeyAction = (val: string): Action => ({
  type: 'setMainMenuObjAction',
  payload: val,
})

export const setLoginInfoAction = (val?: LoginRes): Action => ({
  type: 'setLoginInfoAction',
  payload: val,
})

export const setExpressListAction = (val: ExpressCompanyRes[]): Action => ({
  type: 'setExpressListAction',
  payload: val,
})

export const getExpressListAction = (): Action => ({
  type: 'getExpressListAction',
})
import { ReactNode } from 'react'
import { MainMenuKey } from '../../route'
import { RouteListParam } from '../../tools/public'
import { LoginRes } from '../../api/CommonApi'
import { ExpressCompanyRes } from '../../api/orderManage'

interface enterpriseInfoState {
  corporate?: string
  date?: string
  enterpriseName?: string
  id?: string
  licenseUrl?: string
  regAddress?: string
  regCapital?: string
  regStatus?: string
  uscc?: string
}
export interface CustomMenuItem {
  icon?: ReactNode
  label: string
  key: React.Key
  children?: CustomMenuItem[]
  url?: string
  [key: string]: any
}

type RouterObj = {
  [keyname in MainMenuKey]: RouteListParam[]
}
type MainMenuObj = {
  [keyname in MainMenuKey]: any[]
}
interface State {
  enterpriseInfo?: enterpriseInfoState
  routerObj: RouterObj
  mainMenuObj: MainMenuObj
  orderassuranceTabKey: string
  loginInfo?: LoginRes
  expressList: ExpressCompanyRes[]
}
export type ActionType =
  | 'setEnterpriseInfo'
  | 'setRouterObjAction'
  | 'setMainMenuObjAction'
  | 'setMainMenuListAction'
  | 'setOrderassuranceTabKeyAction'
  | 'setLoginInfoAction'
  | 'setExpressListAction'
  | 'getExpressListAction'

interface Action {
  type: ActionType
  payload?: any
}

export const initialRouterObj: {
  [key in MainMenuKey]: RouteListParam[]
} = {
  基本信息: [],
  物料管理: [],
  询报价: [],
  订单管理: [],
  客户开票: [],
  开票付款: [],
  系统管理: [],
}

export const initialMainMenu: {
  [key in MainMenuKey]: any[]
} = {
  基本信息: [],
  物料管理: [],
  询报价: [],
  订单管理: [],
  客户开票: [],
  开票付款: [],
  系统管理: [],
}
const initialState: State = {
  enterpriseInfo: undefined,
  routerObj: initialRouterObj,
  mainMenuObj: initialMainMenu,
  orderassuranceTabKey: 'CUSTOMER',
  loginInfo: undefined, // 登录接口获取的信息
  expressList: [],
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setEnterpriseInfo':
      newstate.enterpriseInfo = action.payload
      return newstate
    case 'setRouterObjAction':
      newstate.routerObj = action.payload
      return newstate
    case 'setMainMenuObjAction':
      newstate.mainMenuObj = action.payload
      return newstate
    case 'setOrderassuranceTabKeyAction':
      newstate.orderassuranceTabKey = action.payload
      return newstate
    case 'setLoginInfoAction':
      newstate.loginInfo = action.payload
      return newstate
    case 'setExpressListAction':
      newstate.expressList = action.payload
      return newstate
    default:
      return newstate
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
export const setEnterpriseInfo = (val: any): Action => ({
  type: 'setEnterpriseInfo',
  payload: val,
})

/**
 * 设置整理好的路由对象
 * @param val
 * @returns
 */
export const setRouterObjAction = (val: RouterObj): Action => ({
  type: 'setRouterObjAction',
  payload: val,
})

/**
 * 设置整理好的主菜单
 * @param val
 * @returns
 */
export const setMainMenuObjAction = (val: MainMenuObj): Action => ({
  type: 'setMainMenuObjAction',
  payload: val,
})

export const setOrderassuranceTabKeyAction = (val: string): Action => ({
  type: 'setMainMenuObjAction',
  payload: val,
})

export const setLoginInfoAction = (val?: LoginRes): Action => ({
  type: 'setLoginInfoAction',
  payload: val,
})

export const setExpressListAction = (val: ExpressCompanyRes[]): Action => ({
  type: 'setExpressListAction',
  payload: val,
})

export const getExpressListAction = (): Action => ({
  type: 'getExpressListAction',
})
